module.exports = __webpack_public_path__ + "img/uri.b6f73256.jpeg";